module.exports = __webpack_public_path__ + "static/media/OswaldBold.e79b506a.eot";